import { render, staticRenderFns } from "./CashBookManage.vue?vue&type=template&id=58680ba6&scoped=true"
import script from "./CashBookManage.vue?vue&type=script&lang=js"
export * from "./CashBookManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58680ba6",
  null
  
)

export default component.exports